import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { } from "react";
import LoaderContainer from "commons/container/LoaderContainer";
import PropTypes from 'prop-types';
import { useGetDocMetaQuery, useGetProjectQuery } from "../../redux/api/cache";

function Notification(props) {
    const { data: projet, isLoading } = useGetProjectQuery({ seq: props.keys.camp_seq });
    const { data: docMetas, isLoading: docMetasLoading } = useGetDocMetaQuery(props.keys.ridDoc, { skip: !props.keys.ridDoc });

    return <>{!props.isRequis && !isLoading && !docMetasLoading && (<GridLayout style={{ overflowX: "auto", width: "100%", display: "block" }} cols={[{ width: 'auto' }]} rows={[{ height: 'auto' }, { height: 'auto' }, { height: 'auto' }, { height: 'auto' }]}>
        <GridLayoutItem className="notification-grid" row={1} col={1}>
            <h3 style={{ marginBottom: "20px" }}><b>{props.item.tac_texte}</b>
            </h3>
        </GridLayoutItem>
        <GridLayoutItem className="notification-grid" row={2} col={1}>
            <p className="notification-field">
                <b><span style={{ textDecoration: "underline" }}>Campagne:</span></b>&emsp;{projet?.data[0]?.camp_descr} ({projet?.data[0]?.camp_num})
            </p>
        </GridLayoutItem>
        <GridLayoutItem className="notification-grid" row={3} col={1}>
            <p className="notification-field">
                <b><span style={{ textDecoration: "underline" }}>Media:</span></b>&emsp;{props.keys.media_cd}
            </p>
        </GridLayoutItem>
        <GridLayoutItem className="notification-grid" row={4} col={1} style={{ position: 'sticky', right: 0 }}>
            <p className="notification-field">
                <b><span style={{ textDecoration: "underline" }}>{`Date limite d'approbation:`}</span></b>&emsp;{docMetas?.data?.find(d => d.docm_descr === 'DocDtLimite').docm_val}
            </p>
        </GridLayoutItem>
    </GridLayout>)}
        {props.isRequis && !isLoading && (<GridLayout style={{ overflowX: "auto", width: "100%", display: "block" }} cols={[{ width: 'auto' }]} rows={[{ height: 'auto' }, { height: 'auto' }, { height: 'auto' }]}>
            <GridLayoutItem className="notification-grid" row={1} col={1}>
                <h3 style={{ marginBottom: "20px" }}><b>Vous avez des produits à ajouter!</b>
                </h3>
            </GridLayoutItem>
            <GridLayoutItem className="notification-grid" row={2} col={1}>
                <p className="notification-field">
                    <b><span style={{ textDecoration: "underline" }}>Campagne:</span></b>&emsp;{projet?.data[0]?.camp_descr} ({projet?.data[0]?.camp_num})
                </p>
            </GridLayoutItem>
            <GridLayoutItem className="notification-grid" row={3} col={1}>
                <p className="notification-field">
                    <b><span style={{ textDecoration: "underline" }}>Media:</span></b>&emsp;{props.keys.media_cd}
                </p>
            </GridLayoutItem>
        </GridLayout>)}
        {isLoading && <LoaderContainer style={{ height: '100px' }} />}
    </>;
}

Notification.propTypes = {
    isRequis: PropTypes.bool,
    keys: PropTypes.any,
    item: PropTypes.any
};

export default React.memo(Notification);